// extracted by mini-css-extract-plugin
export default {"loadingContainer":"LoadingSpinner_loadingContainer__riURw","spinner":"LoadingSpinner_spinner__Tk4dF","spin":"LoadingSpinner_spin__UsiHa"};